export default function getVariation(placement) {
  return placement.split('-')[1];
}


//////////////////
// WEBPACK FOOTER
// ../~/@popperjs/core/lib/utils/getVariation.js
// module id = 476
// module chunks = 121